import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {RecommendModel} from '../../../shared/models/recommend.model';
import {RecommentCandidateCompanyService} from './recomment-candidate.service';
import {ActivatedRoute} from '@angular/router';
import {UserDataService} from '../../../modules/auth/user-data.service';

@Component({
    selector: 'app-recommend-candidate',
    templateUrl: './recommend-candidate.component.html',
    styleUrls: ['./recommend-candidate.component.scss']
})
export class RecommendCandidateComponent implements OnInit {
    constructor(private http: HttpClient,
                private route: ActivatedRoute,
                private createRecommendationCandidateCompanyService: RecommentCandidateCompanyService,
                public userDataService: UserDataService) {

    }

    formResponse: boolean;
    formSent: boolean;

    recommendCandidateId: number;
    recommendCandate: object;
    recommendCompany: object;
    isLoading = false;
    isDisplayedCandidate = true;
    isDisplayedCompany = false;
    userData: any;
    succesMessage: string;
    formHasBeenSend = false;
    fullName: string;

    personalGdprChecked: boolean;
    recomGdprChecked: boolean;


    personalGdprCheckedCand: boolean;
    recomGdprCheckedCand: boolean;

    ngOnInit(): void {
        this.userDataService.getData()
            .subscribe(user => {
                this.userData = user;
                this.fullName = this.userData.lastName + ' ' + this.userData.firstName;
            }, error => {
            });
    }
// submit form Candidate


    onSubmitCandidate(recommendFormCandidate: NgForm) {
        this.isLoading = true;
        this.recommendCandate = {
            name: recommendFormCandidate.value.name,
            recommendedBy: recommendFormCandidate.value.recommendedBy,
            recommendationType: 'candidate',
            email: recommendFormCandidate.value.email,
            telephone: recommendFormCandidate.value.telephone,
            facebookLink: recommendFormCandidate.value.facebookLink,
            linkedinLink: recommendFormCandidate.value.linkedinLink,
            message: recommendFormCandidate.value.message,
            status: 'new',
            recommendedGDPR: this.recomGdprCheckedCand,
            gdpr: this.personalGdprCheckedCand
        }

        if(recommendFormCandidate.valid && this.personalGdprCheckedCand && this.recomGdprCheckedCand) {
            this.createRecommendationCandidateCompanyService.createRecommendationCandidate(this.recommendCandate).subscribe(responseData => {

                this.formResponse = true;
                this.formSent = true;

                setTimeout(() => {
                    this.formResponse = true;
                    recommendFormCandidate.resetForm();

                }, 4000);

            }, error => {
                this.formResponse = false;
                this.formSent = true;

                setTimeout(() => {
                    this.formResponse = true;
                    // recommendFormCandidate.resetForm();
                }, 4000);
            })
        } else {
            this.formResponse = false;
            this.formSent = true;
            setTimeout(() => {
                this.formResponse = false;
                this.formSent = true;
                // recommendFormCandidate.resetForm();
            }, 4000);
        }

    }

    onSubmitCompany(recommendFormCompany: NgForm) {

        this.isLoading = true;
        this.recommendCompany = {
            name: recommendFormCompany.value.name,
            recommendedBy: recommendFormCompany.value.recommendedBy,
            recommendationType: 'company',
            email: recommendFormCompany.value.email,
            telephone: recommendFormCompany.value.telephone,
            facebookLink: recommendFormCompany.value.facebookLink,
            linkedinLink: recommendFormCompany.value.linkedinLink,
            message: recommendFormCompany.value.message,
            status: 'new',
            recommendedGDPR: this.recomGdprChecked,
            gdpr: this.personalGdprChecked
        }

        if(recommendFormCompany.valid && this.recomGdprChecked && this.personalGdprChecked) {
            this.createRecommendationCandidateCompanyService
                .createRecommendationCompany(this.recommendCompany).subscribe(responseData => {
                this.formResponse = true;
                this.formSent = true;
                setTimeout(() => {
                    this.formSent = false;
                    recommendFormCompany.resetForm();
                }, 4000);
            }, error => {
                this.formResponse = false;
                this.formSent = true;
                setTimeout(() => {
                    this.formSent = false;
                    // recommendFormCompany.resetForm();
                }, 4000);
            })
        } else {
            this.formResponse = false;
            this.formSent = true;
            setTimeout(() => {
                this.formSent = false;
                // recommendFormCompany.resetForm();
            }, 4000);
        }
    }


    displayFormCandidate() {
        this.isDisplayedCompany = true;
        this.isDisplayedCandidate = false;

    }
    displayFormCompany() {
        this.isDisplayedCandidate = true;
        this.isDisplayedCompany = false;

    }

}
